import { Card } from "@mui/joy";
import { CheckCircle2 } from "lucide-react";

// Define the review type
type Review = {
  id: number;
  name: string;
  username: string;
  quote: string;
  imageUrl: string;
  size?: "large" | "small";
};

// Reviews data
const reviews: Review[] = [
  {
    id: 1,
    name: "Parl Coppa",
    username: "@coppalipse",
    quote:
      "This is the best thing since sliced bread. I cannot believe I did not think of it myself.",
    imageUrl: "https://placehold.co/40x40/EEE/31343C?font=oswald&text=Oswald",
    size: "large",
  },
  {
    id: 2,
    name: "Mathew",
    username: "@heymatt_oo",
    quote:
      "After using this, I cannot imagine going back to the old way of doing things.",
    imageUrl: "https://placehold.co/40x40/EEE/31343C?font=oswald&text=Oswald",
    size: "large",
  },
  {
    id: 3,
    name: "Joshua",
    username: "@joshua",
    quote: "Perfect for my use case",
    imageUrl: "https://placehold.co/40x40/EEE/31343C?font=oswald&text=Oswald",
    size: "small",
  },
  {
    id: 4,
    name: "Mandy",
    username: "@mandy",
    quote: "Excellent product!",
    imageUrl: "https://placehold.co/40x40/EEE/31343C?font=oswald&text=Oswald",
    size: "small",
  },
  {
    id: 5,
    name: "Alex",
    username: "@alex",
    quote: "Can easily recommend!",
    imageUrl: "https://placehold.co/40x40/EEE/31343C?font=oswald&text=Oswald",
    size: "small",
  },
];

export default function Testimonials({ dark }: { dark: boolean }) {
  return (
    <section
      id="events"
      className="w-full md:py-24 lg:py-10 hide-scrollbar "
      style={{ backgroundColor: dark ? "" : "#f9fafb" }}
    >
      <div className="max-w-6xl mx-auto px-4 py-16 space-y-6" id="testimonials">
        <div className="text-center mb-12">
          <h2
            className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-center mb-4 "
            style={{ color: dark ? "#38BDF8" : "#7B3FE4" }}
          >
            Don&apos;t take it from us
          </h2>
          <p className="text-xl">See what other people have to say.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4">
          {reviews.map((review) => (
            <Card
              key={review.id}
              className={`rounded-2xl p-6 shadow-sm border 
              ${review.size === "large" ? "lg:col-span-3" : "lg:col-span-2"}
              ${review.id >= 3 ? "md:col-span-1" : "md:col-span-2"}
            `}
              sx={{
                backgroundColor: dark ? "#1f2937" : "bg-white",
              }}
            >
              <p className="text-lg mb-4">&quot;{review.quote}&quot;</p>
              <div className="flex items-center gap-3">
                <img
                  src={review.imageUrl}
                  alt={review.name}
                  width={40}
                  height={40}
                  className="rounded-full"
                />
                <div>
                  <div className="flex items-center gap-1">
                    <span className="font-semibold">{review.name}</span>
                    <CheckCircle2 className="w-4 h-4 text-blue-500" />
                  </div>
                  <span className="text-gray-500 text-sm">
                    {review.username}
                  </span>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
